<wl-partial-card class="p-4">
  <ng-container slot="content">
    <div class="d-flex flex-column gap-2 align-items-start w-100">
      @if (!salesFunnelVM().filled) {
        <ng-container *ngTemplateOutlet="missingData" />
      } @else {
        @switch (step()) {
          @case (SmartChargingLeadWidgetStep.ChargingStationForm) {
            <ng-container *ngTemplateOutlet="chargingStationFormStep" />
          }
          @case (SmartChargingLeadWidgetStep.ChargingStationRejected) {
            <ng-container *ngTemplateOutlet="chargingStationRejectedStep" />
          }
          @case (SmartChargingLeadWidgetStep.LicensePlateForm) {
            <ng-container *ngTemplateOutlet="licensePlateFormStep" />
          }
          @case (SmartChargingLeadWidgetStep.LicensePlateAccepted) {
            <ng-container *ngTemplateOutlet="licensePlateAcceptedStep" />
          }
          @case (SmartChargingLeadWidgetStep.LicensePlateRejected) {
            <ng-container *ngTemplateOutlet="licensePlateRejectedStep" />
          }
          @case (SmartChargingLeadWidgetStep.LicensePlateUnknown) {
            <ng-container *ngTemplateOutlet="licensePlateUnknownStep" />
          }
          @case (SmartChargingLeadWidgetStep.ThankYouScreen) {
            <ng-container *ngTemplateOutlet="thankYouScreen" />
          }
        }
      }
    </div>
  </ng-container>
</wl-partial-card>

<!-- Widget steps -->

<ng-template #missingData>
  <span class="heading">{{ content().missingDataTitle }}</span>
  <span *wlGenericRichText="{ value: content().missingDataBody }"></span>
  <crnt-button
    variant="primary"
    [fullWidth]="true"
    [href]="content().smartChargingInfoLink?.href"
    [target]="content().smartChargingInfoLink?.target || '_blank'"
  >
    {{ content().smartChargingInfoLink?.text }}
    <crnt-icon slot="trailing" icon="arrow-right" />
  </crnt-button>
</ng-template>

<ng-template #chargingStationFormStep>
  <span class="card-title">{{ content().step1.title }}</span>
  <crnt-radio-group>
    <crnt-form-control-label slot="legend">
      <span>{{ content().step1.inputLabel }}</span>
    </crnt-form-control-label>
    <crnt-form-control-label slot="help">
      <span class="fw-normal">{{ content().step1.inputHelp }}</span>
    </crnt-form-control-label>
    @if (
      chargingStationForm().controls.hasChargingStation.isPristine &&
      chargingStationForm().controls.hasChargingStation.errors['required']
    ) {
      <crnt-form-control-validation-message slot="validation">
        {{ content().step1.inputRequiredError }}
      </crnt-form-control-validation-message>
    }
    <crnt-radio>
      <label slot="label">{{ content().step1.optionYes }}</label>
      <input
        type="radio"
        [ngrxFormControlState]="
          chargingStationForm().controls.hasChargingStation
        "
        [value]="true"
      />
    </crnt-radio>
    <crnt-radio>
      <label slot="label">{{ content().step1.optionNo }}</label>
      <input
        type="radio"
        [ngrxFormControlState]="
          chargingStationForm().controls.hasChargingStation
        "
        [value]="false"
      />
    </crnt-radio>
  </crnt-radio-group>
  <div class="w-100">
    <crnt-button
      variant="primary"
      type="submit"
      [fullWidth]="true"
      (click)="submitChargingStationForm()"
    >
      {{ content().step1.primaryButton }}
      <crnt-icon slot="trailing" icon="arrow-right"></crnt-icon>
    </crnt-button>
    <ng-container *ngTemplateOutlet="stepIndicatorFragment" />
  </div>

  <crnt-callout class="w-100">
    <span slot="title">{{ content().step1.infoTitle }}</span>
    <span>{{ content().step1.infoBody }}&#32;</span>
    <a
      class="color-revert"
      *wlGenericLink="{ value: content().chargingStationsInfoLink }"
    ></a>
  </crnt-callout>
</ng-template>

<ng-template #chargingStationRejectedStep>
  <ng-container *ngTemplateOutlet="backLinkFragment" />
  <span class="heading">{{ content().step1.rejectedTitle }}</span>
  <div>
    <span *wlGenericRichText="{ value: content().step1.rejectedBody }"></span>
    <crnt-button
      variant="tertiary"
      [fullWidth]="false"
      [href]="content().chargingStationsInfoLink?.href"
      [target]="content().chargingStationsInfoLink?.target || '_blank'"
    >
      {{ content().chargingStationsInfoLink?.text }}
      <crnt-icon slot="trailing" icon="external-link" />
    </crnt-button>
  </div>
</ng-template>

<ng-template #licensePlateFormStep>
  <span class="card-title">{{ content().step2.title }}</span>
  <crnt-form-control>
    <crnt-form-control-label slot="label">
      {{ content().step2.inputLabel }}
    </crnt-form-control-label>
    <crnt-form-control-label slot="help">
      <span class="fw-light">{{ content().step2.inputHelp }}</span>
    </crnt-form-control-label>
    @if (
      licensePlateCheckForm().isSubmitted && licensePlateCheckForm().isInvalid
    ) {
      @if (licensePlateCheckForm().controls.licensePlate.errors['required']) {
        <crnt-form-control-validation-message slot="validation">
          {{ content().step2.inputRequiredError }}
        </crnt-form-control-validation-message>
      } @else {
        <crnt-form-control-validation-message slot="validation">
          {{ content().step2.invalidValueError }}
        </crnt-form-control-validation-message>
      }
    }
    <crnt-text-input>
      <crnt-icon icon="id-card" slot="leading"></crnt-icon>
      <input
        type="text"
        [ngrxFormControlState]="licensePlateCheckForm().controls.licensePlate"
      />
    </crnt-text-input>
  </crnt-form-control>

  @switch (licensePlateLookupState().status) {
    @case ('PENDING') {
      <div class="lookup-status text-align-center">
        <crnt-icon icon="spinner-third" animation="spin" />
      </div>
    }
    @case ('SUCCESS') {
      @switch (licensePlateLookupState().data?.support_status) {
        @case ('unknown') {
          <div
            class="lookup-status"
            *wlGenericRichText="{ value: content().step2.licensePlateError }"
          ></div>
          <!-- TODO: info modal link (CTR-2208) -->
        }
        @case ('supported') {
          <div class="lookup-status">
            <crnt-icon class="green me-1" icon="check" />{{
              content().step2.licensePlateFound
            }}
          </div>
        }
        @case ('not_supported') {
          <div class="lookup-status">
            <crnt-icon class="green me-1" icon="check" />{{
              content().step2.licensePlateFound
            }}
          </div>
        }
      }
    }
    @case ('ERROR') {
      <crnt-callout class="w-100" variant="negative">
        <span slot="title">{{ content().step2.serverErrorTitle }}</span>
        <span>{{ content().step2.serverErrorBody }}</span>
      </crnt-callout>
    }
  }

  <span>{{ content().step2.additionalText }}</span>
  <div class="w-100">
    <div class="d-flex gap-1 align-items-center">
      <crnt-button class="flex-1" variant="secondary" (click)="stepBack()">
        <crnt-icon slot="leading" icon="arrow-left" />
        {{ content().backToStep }} {{ stepIndicator().step - 1 }}
      </crnt-button>
      <crnt-button
        class="flex-1"
        variant="primary"
        [state]="
          licensePlateLookupState().status === 'PENDING'
            ? 'processing'
            : licensePlateLookupState().status === 'ERROR'
              ? 'disabled'
              : 'enabled'
        "
        (click)="submitLicensePlateCheckForm()"
      >
        {{ content().step2.primaryButton }}
        <crnt-icon slot="trailing" icon="arrow-right" />
      </crnt-button>
    </div>
    <ng-container *ngTemplateOutlet="stepIndicatorFragment" />
  </div>
</ng-template>

<ng-template #licensePlateAcceptedStep>
  <span class="heading">{{ content().step2.acceptedTitle }}</span>
  <span
    *wlGenericRichText="{
      value:
        content().step2.acceptedBody
        | interpolate
          : {
              variables: {
                carBrand: licensePlateLookupState().data?.brand ?? null,
              },
            },
    }"
  ></span>
  <crnt-button variant="primary" [fullWidth]="true" (click)="submitLead()">
    {{ content().step2.acceptedPrimaryButton }}
    <crnt-icon slot="trailing" icon="arrow-right" />
  </crnt-button>
  <crnt-button variant="tertiary" [fullWidth]="true" (click)="stepBack()">
    {{ content().step2.acceptedSecondaryButton }}
  </crnt-button>
</ng-template>

<ng-template #licensePlateRejectedStep>
  <span class="heading">{{ content().step2.rejectedTitle }}</span>
  <span
    *wlGenericRichText="{
      value:
        content().step2.rejectedBody
        | interpolate
          : {
              variables: {
                carBrand: licensePlateLookupState().data?.brand ?? null,
              },
            },
    }"
  ></span>
  <!-- TODO: info modal link (CTR-2208) -->
</ng-template>

<ng-template #licensePlateUnknownStep>
  <span class="heading">{{ content().step2.unknownTitle }}</span>
  <span *wlGenericRichText="{ value: content().step2.unknownBody }"></span>
  <crnt-button variant="primary" [fullWidth]="true" (click)="submitLead()">
    {{ content().step2.acceptedPrimaryButton }}
    <crnt-icon slot="trailing" icon="arrow-right" />
  </crnt-button>
  <crnt-button variant="tertiary" [fullWidth]="true" (click)="stepBack()">
    {{ content().step2.acceptedSecondaryButton }}
  </crnt-button>
</ng-template>

<ng-template #thankYouScreen>
  <span class="heading">{{ content().step3.title }}</span>
  <span
    *wlGenericRichText="{
      value:
        content().step3.body
        | interpolate: { variables: { emailAddress: salesFunnelVM().email } },
    }"
  ></span>
</ng-template>

<!-- Fragments -->

<ng-template #backLinkFragment>
  <crnt-button variant="tertiary" [fullWidth]="false" (click)="stepBack()">
    <crnt-icon slot="leading" icon="arrow-left" />
    <span>{{ content().backToStep }} {{ stepIndicator().step }}</span>
  </crnt-button>
</ng-template>

<ng-template #stepIndicatorFragment>
  <div class="mt-1 text-align-center">
    <span>
      <span class="fw-bold">{{ stepIndicator().step }}</span>
      {{ stepIndicator().of }} {{ stepIndicator().steps }}
    </span>
  </div>
</ng-template>
